
import { defineComponent } from 'vue'

class NewsData {
  extension: string;
  text: string;
  date: string;
  version: string;
  extensionData: any = null;
  constructor (extension: string, text: string, date: string, version: string) {
    this.extension = extension
    this.text = text
    this.date = date
    this.version = version

    this.extensionData = require(`@/data/${this.extension}/meta.json`)
  }
}

export default defineComponent({
  name: 'NewsPanel',

  data () {
    return {
      news: Array<NewsData>()
    }
  },

  created () {
    import('@/data/news.json').then((data) => {
      const limitedData = data.default.slice(0, 10)
      limitedData.forEach((value) => {
        this.news.push(new NewsData(value.extension, value.text, value.date, value.version))
      })
    })
  },

  methods: {
    imgUrl (name: string): string {
      return require('@/data/' + name + '/image.png')
    }
  }
})

